<template>
  <div>
    <div class="flied">
        <div @click="centerDialogVisiblestol = true">
            <!-- <img src="@/assets/img/icon_01.png" /> -->
            <span>客服咨询</span>
        </div>
        <div @click='toTop'>
            <img src="@/assets/img/icon_02.png" />
        </div>
    </div>

    <van-popup v-model="centerDialogVisiblestol" round >
        <div class="lq_box" style="background-color: #fff;padding: 1rem;">
            <div class="lq_image" style="width: 4rem;height: auto;margin: auto;">
                <img src="https://www.5kjs.com/information/assets/images/wlbkefu.png" style="width: 100%;">
            </div>
            <div class="lq_title" style="text-align: center;font-size: 0.32rem;margin-top: 0.2rem;color: #000;">
                添加客服微信，一对一咨询湖南教师招聘考情
            </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Popup } from 'vant'
  Vue.use(Popup);
  import login from '@/components/login/index.vue'
  import Bottom from '@/components/bottom/index.vue'
  import proposal from '@/components/proposal/index.vue'
  export default {
    name: "detail",
    data() {
      return {
          centerDialogVisiblestol: false,
          data_inof: {},
      };
    },
    props:['api_token', 'agency_id'],
    created() {
        if(localStorage.getItem('subject') != null) {
          this.data_inof = JSON.parse(localStorage.getItem('data_inof'))
      }
    },
    methods:{
        //返回顶部
        toTop() {
            document.documentElement.scrollTop = 0;
        },
        //点击反馈
        fai_ku(e) {
            e.stopPropagation()
            e.preventDefault()
        }
    },
    mounted() {
    },
    components: {
      login,Bottom,proposal
    },
  };
</script>

<style lang="less" scoped>
.flied {
    position: fixed;
    right: .3rem;
    bottom: 2rem;
    z-index: 4;
    > div {
        width: 0.93rem;
        height: 0.93rem;
        background: rgba(255,255,255,0.9);
        box-shadow: 0rem 0rem 10px rgba(71, 76, 100, 0.19);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .3rem;
        > span {
            width:.5rem;
            font-size: .18rem;
            color: #545664;
        }
        > img {
            height: .43rem;
        }
    }
}
</style>
